import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { createPortal } from 'react-dom';
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { Pages, NavigationFunction as RootNavigation } from "../../Navigation/Routers/root";
import { colors, frames, icons, useMediaQuery } from "../../Styles";
import { ButtonList, LogoDisplay, Overlay } from "../../Components";
import { ButtonTypes, ListStyle_Types } from '../../Definitions';
import { SystemMenu } from "..";

// TODO
import MenuButton from '../../Components/menuButton';
import StatusList from '../../Components/statusList';

export default function OperationspanelLayout() {
  const {t} = useTranslation()
  const location = useLocation();
  const navigator = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const groupMenu2columns = useMediaQuery(`(max-width: 454px)`);
  const groupMenu3columns = useMediaQuery(`(min-width: 455px) and (max-width: 590px)`);

  const [showSystemMenu, setShowSystemMenu] = useState(false);
  const [showStatusBar, setShowStatusBar] = useState(false);
  
  const BtnFunc_Router = (btn_index: number) => {
    switch (btn_index) {
      case 0:
        RootNavigation(navigator, Pages.op_operations)
        setShowStatusBar(false);
        setShowSystemMenu(false);
        break;
      case 1:
        setShowSystemMenu(true);
        setShowStatusBar(false);
        break;
      case 2:
        setShowStatusBar(true);
        setShowSystemMenu(false);
        break;
      case 3:
        RootNavigation(navigator, Pages.op_animals)
        setShowStatusBar(false);
        setShowSystemMenu(false);
        break;
      case 4:
        RootNavigation(navigator, Pages.op_quickEntry)
        setShowStatusBar(false);
        setShowSystemMenu(false);
        break;
      default:
        alert("Error")
    }
  };

  const _style: React.CSSProperties = {
    gridArea: "2/1/3/2",
    display: "flex",
    alignItems: "end",
    overflow: "hidden",
    maxHeight: "100%"
  };

  // To show or not to show menu
  const toggleComponents = () => {
    setMenuOpen(!menuOpen);
  };

  // Reset showComponents to false when the location changes
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return ( <>
    <MenuButton menuState={menuOpen} onClick={toggleComponents}/>

    <frames.OperationsPanel>
      {menuOpen && createPortal ( <>
        <Overlay
          overrides={{
            zIndex: menuOpen ? 99999 : 0,
            blur: true
          }}
          content={
            <div style={{boxSizing: "border-box", display: "grid", gridTemplateColumns: "1fr", gridTemplateRows: "150px 1fr auto", rowGap: "10px", position: "relative", zIndex: "999999", padding: "10px", height: "100%", width: "100%"}}>
              <div style={{gridArea: "1/1/2/2", overflow: "visible"}}><LogoDisplay ChooseSite selectedPage={Pages.op_operations}/></div>
              <div style={_style}>{showSystemMenu && <SystemMenu/>}</div>
              <div style={_style}>{showStatusBar && <StatusList/>}</div>
              <div style={{gridArea: "3/1/4/2"}}>
                <div style={{width: "100%", height: "fit-content", maxWidth: "555px", padding: "7.5px", boxSizing: "border-box", backgroundColor: colors.greyDarkPrimary, borderRadius: (showSystemMenu||showStatusBar) ? "0px 0px 10px 10px" : "10px", margin: "0px auto", display: "flex", justifyContent: "center"}}>
                <div style={{width: groupMenu2columns ? "265px" : groupMenu3columns ? "400px" : "535px"}}>
                  <ButtonList 
                    contents={[
                      t(`menuHeaders.${Pages.op_operations}`, {defaultValue: "operations"}), 
                      t("menuHeaders.systemMenu", {defaultValue: "system menu"}), 
                      t("menuHeaders.attentions", {defaultValue: "attentions"}), 
                      t(`menuHeaders.${Pages.animals}`, {defaultValue: "animals"}), 
                      t("menuHeaders.quickEntry", {defaultValue: "quick entry"})
                    ]}
                    onClick={(e) => BtnFunc_Router(e)}
                    buttonType={ButtonTypes.globalMenuButton}
                    overrides={{
                      startEnhancerStyles: {width: "25px", height: "25px"},
                      hoverStyles: {backgroundColor: colors.greyDarkSecondary}
                    }}
                    hasActiveLoad
                    listOverrides={{
                      listStyle: ListStyle_Types.group
                    }}
                    startEnhancers={[
                      icons.globalSettings, icons.globalSettings, icons.globalSettings, icons.globalSettings, icons.globalSettings
                    ]}/>
                  </div>
                </div>
              </div>
            </div>
          }
        />
      </>, document.body )}
      <div style={{ gridArea: "page_outer", overflow: "hidden", height: "100%"}}>
        <Outlet /> 
      </div>
    </frames.OperationsPanel>
  </> );
};